import type { ReportParameter, ReportParameterMappingType } from './types';

export const CLAIM_PRESETS = [
  'user_id',
  'department_id',
  'role_id',
  'tenant_id',
  'email',
  'sub',
] as const;

export const CUSTOM_CLAIM_OPTION = '__custom_claim__';

export const CUSTOM_PARAMETER_VALUE = 'Default';

export function createEmptyReportParameter(
  partial?: Partial<ReportParameter>
): ReportParameter {
  const name = partial?.name ?? '';
  const mappingType = partial?.mapping_type ?? 'custom';
  return {
    name,
    mapping_type: mappingType,
    isrequired: partial?.isrequired ?? false,
    value:
      mappingType === 'custom'
        ? CUSTOM_PARAMETER_VALUE
        : (partial?.value ?? CLAIM_PRESETS[0]),
  };
}

export function normalizeReportParameter(
  param: Partial<ReportParameter> & { name: string; value: string }
): ReportParameter {
  const mappingType: ReportParameterMappingType =
    param.mapping_type === 'inherit_from_claims' ? 'inherit_from_claims' : 'custom';

  return {
    name: param.name.trim(),
    mapping_type: mappingType,
    isrequired: param.isrequired ?? false,
    value: mappingType === 'custom' ? CUSTOM_PARAMETER_VALUE : param.value.trim(),
  };
}

export function applyParameterMappingTypeChange(
  param: ReportParameter,
  mappingType: ReportParameterMappingType
): ReportParameter {
  if (mappingType === 'custom') {
    return {
      ...param,
      mapping_type: 'custom',
      value: CUSTOM_PARAMETER_VALUE,
    };
  }

  const claimValue = CLAIM_PRESETS.includes(param.value as (typeof CLAIM_PRESETS)[number])
    ? param.value
    : CLAIM_PRESETS[0];

  return {
    ...param,
    mapping_type: 'inherit_from_claims',
    value: claimValue,
  };
}

export function applyParameterNameChange(
  param: ReportParameter,
  name: string
): ReportParameter {
  return { ...param, name };
}
